import { palette, Typography } from "@powerdiary/components-library/lib";
import { amountToCurrency } from "../localeHelper";
import { ICardFee } from "./types";

export default function StripeFee({ enabled, fee, currencySymbol }: ICardFee) {
    return (
        <>
            {enabled && (
                <Typography variant="paragraphMediumRegular" color={palette.dusk["700"]} className="text-center">
                    {`Card processing fee of ${amountToCurrency(fee, currencySymbol)} applies`}
                </Typography>
            )}
        </>
    );
}
